
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "32px",
    "height": "32px",
    "viewBox": "0 0 32 32",
    "enable-background": "new 0 0 32 32",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "currentColor",
        "width": "32",
        "height": "32"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "currentColor",
        "d": "M23.333,24.259h-2.666v-1.374h2.666\n\tc0.737,0,1.334-0.615,1.334-1.375V7.761c0-0.76-0.597-1.376-1.334-1.376H8.667c-0.736,0-1.333,0.616-1.333,1.376V21.51\n\tc0,0.76,0.597,1.375,1.333,1.375h2.666v1.374H8.667C7.195,24.259,6,23.029,6,21.51V7.761C6,6.242,7.195,5.01,8.667,5.01h14.666\n\tC24.806,5.01,26,6.242,26,7.761V21.51C26,23.029,24.806,24.259,23.333,24.259z M10.896,16.732l4.599-4.743\n\tc0.141-0.143,0.324-0.205,0.506-0.195c0.182-0.01,0.366,0.053,0.506,0.195l4.6,4.743c0.261,0.268,0.261,0.704,0,0.973\n\ts-0.684,0.269-0.943,0l-3.495-3.604v12.223c0,0.38-0.299,0.687-0.667,0.687s-0.667-0.307-0.667-0.687V14.101l-3.494,3.604\n\tc-0.259,0.269-0.683,0.269-0.943,0C10.636,17.437,10.636,17,10.896,16.732z"
      }
    }
  ]
})
    }
  